import React from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import { FaUserGraduate, FaProjectDiagram, FaBriefcase } from "react-icons/fa";

import { useIntersectionObserver } from "../../../Assets/CustomHook/CustomHook";
import { FaHandshakeAngle } from "react-icons/fa6";

const statsData = [
  {
    id: 1,
    icon: <FaUserGraduate size={30} />,
    value: 10000,
    label: "Student Admission",
  },
  {
    id: 2,
    icon: <FaProjectDiagram size={30} />,
    value: 500,
    label: "Project Completed",
  },
  {
    id: 3,
    icon: <FaHandshakeAngle size={32} />,
    value: 30,
    label: "MOU Signed Colleges",
  },
  {
    id: 4,
    icon: <FaBriefcase size={30} />,
    value: 100,
    label: "Placement Call",
    suffix: "%",
  },
];

const StatsCounter = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <div ref={ref} className="py-10 bg-gray-50">
      <div className="max-w-7xl px-4 md:px-8 mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {statsData.map((item, index) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.15 }}
            viewport={{ once: true }}
            className="flex flex-col items-center justify-center text-center p-4 
                       bg-white rounded-xl shadow-lg border border-gray-100
                       hover:shadow-xl hover:scale-[1.03] transition-all duration-300"
          >
            <div className="text-indigo-600 mb-2">{item.icon}</div>

            <div className="text-3xl font-extrabold text-gray-900 tracking-tight">
              {isVisible ? (
                <CountUp start={0} end={item.value} duration={3} />
              ) : (
                0
              )}
              {item.suffix || "+"}
            </div>

            <div className="font-medium text-gray-600">{item.label}</div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default StatsCounter;
